















import Vue from 'vue';
import CabinetConfiguration from '@/components/configuration/cabinet/CabinetConfiguration.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { EditMode, CabinetConfigurationModel, StoreConstants } from '@/types';
import { mapActions, mapGetters } from 'vuex';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import { CabinetConfigurationHelper } from '@/mixins';

export default Vue.extend({
  mixins: [CabinetConfigurationHelper],
  data() {
    return {
      isSubmitting: false,
      cabinetConfiguration: {} as CabinetConfigurationModel,
      isLoading: true
    };
  },
  methods: {
    ...mapActions('configurationStore', ['getConfigurationTree']),
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Actions.GetCabinetConfigurationSettingsWithErrorPage
    ]),
    async getCabinetConfigurationSettingsAsync(this: any) {
      await this.getCabinetConfigurationSettingsWithErrorPage();
    },
    async getCabinetConfigurationAsync(this: any) {
      try {
        this.cabinetConfiguration = await CabinetConfigurationService.getCabinetConfigurationWithErrorPageAsync(
          this.$route.params.cabinetId
        );
        this.cabinetConfiguration.configurationChangeId = this.cabinetConfigurationChangeId;
      } catch (error) {
        this.$log(error);
      }
    },
    async onSubmitAsync(this: any, cabinetConfiguration: CabinetConfigurationModel) {
      this.isSubmitting = true;
      try {
        this.cabinetConfiguration = await CabinetConfigurationService.updateCabinetAsync(cabinetConfiguration);
        this.setApplicationDirty(false);
        await this.getConfigurationTree();
        this.navigateToCabinetDashboard(this.$route.params.cabinetId);
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    onCancel(this: any) {
      this.navigateToCabinetDashboard(this.$route.params.cabinetId);
    }
  },
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChangeId
    ]),
    editMode(this: any) {
      return this.validLock ? EditMode.Edit : EditMode.View;
    }
  },
  components: {
    CabinetConfiguration,
    LoadingSpinner
  },
  created(this: any) {
    this.EDIT_MODE = EditMode.Edit;
    this.$route.meta.treePath = `/configuration/cabinet/${this.$route.params.cabinetId}/dashboard`;
  },
  async mounted(this: any) {
    await this.getLock();
    await Promise.all([
      this.getCabinetConfigurationAsync(),
      this.getCabinetConfigurationSettingsAsync(),
      this.getAllCabinetNames()
    ]);
    this.isLoading = false;
  },
  beforeDestroy(this: any) {
    this.$route.meta.treePath = null;
  }
});
